import { gql } from "apollo-angular";
import { ILLINKSnippet, INLNK } from "./template-nav-links";

export const HCF = gql`
  fragment HCF on HorizontalCallout {
    sys {
      id
    }
    isPzd
    backgroundColor {
      color
    }
    header
    hTag
    hTagId
    image {
      url
      description
    }
    mediaDatabaseColorLogo
    faIcon
    content
    docLink {
      ...DOCLNK
    }
    linkTitle
    linkTarget
    jumpTarget
    internalLink {
      ${ILLINKSnippet}
    }
    externalLink
    docLink {
      ...DOCLNK
    }
    disclaimerCollection {
      items {
        disclaimer
      }
    }
  }
${INLNK}`;